import { Grid, GridProps } from '@mui/material';

export const GridItem = (props: GridProps) => (<Grid item {...props} />)
